import ContractGroupV2PanelPage from "legacy/contract-groups-v2/ContractGroupV2PanelPage"
import { objectKeysToSnakeCase } from "legacy/helpers.es6"
import FeesAndDiscountsForm from "legacy/manage/FeesAndDiscountsForm"
import { validatorFactory } from "legacy/validatorFactory"
import _ from "lodash"
import PropTypes from "prop-types"
import React from "react"

// Note: Amplitude is loaded globally
// Note: $context is loaded globally

class ContractGroupV2FeesElectricDiscounts extends React.Component {
  constructor(props) {
    super(props)
    this.validator = validatorFactory({ autoForceUpdate: this })
    this.state = {
      feesAndDiscounts: props.form.feesAndDiscounts || [],
      confirmNavigation: false,
    }
    this.next = this.next.bind(this)
    this.updateFeesAndDiscounts = this.updateFeesAndDiscounts.bind(this)
    this.feesAndDiscountsRef = React.createRef()
  }

  componentDidMount() {
    // This is swapping camelCase to snakeCase.
    // There is incosistent use of snakeCase and camelCase in the backend via serializeForReact that causes this to be needed.
    // The long term solution is to normalize the fields to camelCase.
    const fixedFees = this.state.feesAndDiscounts.map((fee) => {
      // if we have a camelCase field for date, swap to snakeCase
      if (fee.startDate) {
        return _.mapKeys(fee, objectKeysToSnakeCase)
      } else {
        return fee
      }
    })
    this.setState({ feesAndDiscounts: fixedFees })
  }

  fetchData() {
    return this.state
  }

  componentWillUnmount() {
    Amplitude.trackEvent("contracts_v2:fees_complete")
    this.props.update(this.state)
  }

  next() {
    if (this.state.confirmNavigation) {
      this.props.route.goNext()
    }
    if (this.feesAndDiscountsRef.current?.hasUnsavedChanges()) {
      this.setState({ confirmNavigation: true })
    } else {
      this.props.route.goNext()
    }
  }

  updateFeesAndDiscounts(newFeesAndDiscounts) {
    this.setState({ feesAndDiscounts: newFeesAndDiscounts })
  }

  render() {
    return (
      <ContractGroupV2PanelPage
        hasNext={this.props.route.hasNext}
        hasPrevious={this.props.route.hasPrevious}
        goNext={this.next}
        goPrevious={this.props.route.goPrevious}
        nextButtonTitle={
          this.state.confirmNavigation ? "Unsaved Fees. Are you sure?" : null
        }
        saving={this.props.saving}
      >
        <FeesAndDiscountsForm
          updateFeesAndDiscounts={this.updateFeesAndDiscounts}
          feesAndDiscounts={this.state.feesAndDiscounts}
          feeCategories={$context.rateOptions.feeCategories}
          pricingStructure={this.props.form.rate.pricingStructure || []}
          startDate={this.props.startDate}
          endDate={this.props.endDate}
          hideLeftColClass="hidden"
          colWidth="block"
          ref={this.feesAndDiscountsRef}
        />
      </ContractGroupV2PanelPage>
    )
  }
}

ContractGroupV2FeesElectricDiscounts.propTypes = {
  form: PropTypes.shape({
    feesAndDiscounts: PropTypes.array,
    rate: PropTypes.shape({
      pricingStructure: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.array,
      ]),
    }),
  }).isRequired,
  update: PropTypes.func.isRequired,
  route: PropTypes.shape({
    hasNext: PropTypes.bool,
    hasPrevious: PropTypes.bool,
    goNext: PropTypes.func,
    goPrevious: PropTypes.func,
  }).isRequired,
  startDate: PropTypes.string,
  endDate: PropTypes.string,
  saving: PropTypes.bool,
}

export default ContractGroupV2FeesElectricDiscounts
